import { ORG_TYPES } from '~/support/constants';

export default {
  allConsumers(state) {
    return state.orgs.filter((org) => org.org_type === ORG_TYPES.consumer);
  },

  allSuppliers(state) {
    return state.orgs.filter((org) => org.org_type === ORG_TYPES.supplier);
  },
};
